import { ApiError } from '@/api/http';

export type FailureKind = 'forbidden' | 'notFound' | 'unavailable';

/** What the person should hear about a failed request: no access, nothing there, or the service did not answer. */
export function failureKind(e: unknown): FailureKind {
  if (e instanceof ApiError) {
    if (e.status === 403) return 'forbidden';
    if (e.status === 404) return 'notFound';
  }
  return 'unavailable';
}

export const failureTitle: Record<FailureKind, string> = {
  forbidden: 'Нет доступа',
  notFound: 'Не найдено',
  unavailable: 'Сервис не ответил',
};

export const failureText: Record<FailureKind, string> = {
  forbidden: 'У вашей роли нет доступа к этому разделу. Если он нужен, попросите владельца аккаунта.',
  notFound: 'Возможно, запись удалили или ссылка устарела.',
  unavailable: 'Это не ваша ошибка: проверьте соединение и попробуйте ещё раз.',
};

/** The text for a toast or an inline message: the BFF's own Russian `detail` when it sent one. */
export function errorMessage(e: unknown): string {
  // `detail` that is only an HTTP status text («Bad Gateway») is not for people.
  if (e instanceof ApiError && /[а-яё]/i.test(e.message)) return e.message;
  const k = failureKind(e);
  return k === 'unavailable' ? 'Сервис не ответил. Попробуйте ещё раз.' : failureTitle[k];
}
